module.exports = __webpack_public_path__ + "img/logo_blue.f5c21217.png";